import path from 'pathe';
import * as prettier from 'prettier';
import type { Formatter } from './config';

export type FormatterConfig = {
	prettierOptions: prettier.Options | null;
};

export const loadFormatterConfig = async ({
	formatter,
	cwd
}: {
	formatter?: Formatter;
	cwd: string;
}): Promise<FormatterConfig> => {
	let prettierOptions: prettier.Options | null = {
		singleQuote: true
	};
	if (formatter === 'prettier') {
		prettierOptions = await prettier.resolveConfig(path.join(cwd, '.prettierrc'));
	}

	return {
		prettierOptions
	};
};
